var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submit-pay"},[_c('div',{staticClass:"total-money"},[_c('span',{staticClass:"total"},[_vm._v("合计：")]),_c('span',{staticClass:"money"},[_c('span',{staticClass:"flag"},[_vm._v("¥")]),_vm._v(_vm._s(_vm.money))])]),_vm._t("default"),_c('div',{staticClass:"submit",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.step))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }